import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

// This hook is always used with wireId memoized.
export default function useGetMediaCarouselMetadata(wireId) {
  return useAxios({
    url: `/api/v1/wire/${wireId}/media/carousel_metadata`,
    method: 'GET',
  }, { manual: true });
}
